import { Box, Button, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import ControlTable from './ControlTable';
import ErrorList from './ErrorList';
import useColorMap from './hooks/useColorMap';
import useControls from './hooks/useControls';
import useErrors from './hooks/useErrors';
import usePrimers from './hooks/usePrimers';
import useSamples from './hooks/useSamples';
import useSelectedSamples from './hooks/useSelectedSamples';
import PrimerTable from './PrimerTable';
import Map from './Map';
import validate from './validate';
import { createSample } from '../../actions/samples';
import Cartridges from './Cartridges';
import Reagent from "./Reagent"

const getWellName = (index) => {
  const column = Math.floor(index / 8);
  const row = String.fromCharCode(index - column * 8 + 'A'.charCodeAt(0));
  return `${row}${column + 1}`;
};

const MapWrapper = ({ sampleMapId, samples, setSamples, primers, setPrimers, colorMap, setColorMap, stage, cartridge, setCartridge, cartridgeData, setCartridgeData, orders }) => {
  const [errors, setErrors] = useState([]);

  const colorMapActions = useColorMap(colorMap, setColorMap);
  const selectedSampleActions = useSelectedSamples();
  const sampleActions = useSamples(
    samples,
    setSamples,
    selectedSampleActions.getSelectedSamples()
  );
  const primerActions = usePrimers(
    sampleMapId,
    primers,
    setPrimers,
    colorMapActions,
    sampleActions
  );
  
  const errorActions = useErrors(errors);

  const machines = ['SeqStudio', 'SeqFlex'];

  const [machine, setMachine] = useState(0);
  const controlActions = useControls(sampleMapId, samples, setSamples);

  useEffect(() => {
    setErrors(validate(stage, samples, machine == 0 ? 4 : 16, cartridgeData));
  }, [samples, machine, cartridgeData]);

  return (
    <>
      {/* <Button onClick={() => {
        createSample({
          well: 95,
          name: 'test sample',
          type: 'sanger',
          concentration: 100,
          readLength: 100,
          volume: 100,
          sampleMap: sampleMapId
        })
      }}>Create test sample</Button> */}
      <Select
        value={machine}
        onChange={(event) => {
          setMachine(event.target.value);
        }}
      >
        <MenuItem value={0}>{machines[0]}</MenuItem>
        <MenuItem value={1}>{machines[1]}</MenuItem>
      </Select>
      <Cartridges sampleMapId={sampleMapId} cartridge={cartridge} setCartridge={setCartridge} setCartridgeData={setCartridgeData} />
      <Reagent sampleMapId={sampleMapId}/>
      <Box display="flex" flexDirection="row">
        <Map
          sampleActions={sampleActions}
          colorMapActions={colorMapActions}
          selectedSampleActions={selectedSampleActions}
          errorActions={errorActions}
        />
        <PrimerTable
          primerActions={primerActions}
          colorMapActions={colorMapActions}
          orders={orders}
        />
      </Box>
      <Box display="flex" flexDirection="row">
        <ControlTable
          controlActions={controlActions}
          getWellName={getWellName}
        />
        <ErrorList errorActions={errorActions} getWellName={getWellName} />
      </Box>
      
    </>
  );
};

export default MapWrapper;
